import PicUpload from '../pic-upload.vue';
export default {
  components: {
    PicUpload
  },
  data() {
    return {
      isShowDialog: false
    };
  },
  methods: {
    show() {
      this.isShowDialog = true;
    },
    cancel() {
      this.isShowDialog = false;
    }
  }
};